import React from 'react';
import { Navigate } from 'react-router-dom';
import { HomeLayout } from 'modules/home/components/HomeLayout';
import { onboardingElementIds } from 'services/onboarding/constants';
import { Stack, Typography } from '@mui/material';
import { useFetchAnalyticsDashboardUrl } from 'modules/analytics/api/useFetchAnalyticsDashboardUrl';
import { isSafariBrowser } from 'core/utils/isSafariBrowser';
import { AlertCard } from 'common/ui';
import { Loading } from 'components/Loading';
import { useIsHomeHidden } from 'modules/layout/hooks/useIsHomeHidden';
import { candidatesLandingPath } from 'modules/layout/constants/candidatesLandingPath';

type Props = {
  isLoading: boolean;
  url: string | undefined;
};

const Dashboard: React.FC<Props> = ({ isLoading, url }) => {
  if (isSafariBrowser()) {
    return (
      <Stack p={4} width="60%">
        <AlertCard type="warning" title="Safari browser detected">
          <Typography variant="default">
            The reporting dashboard is currently not supported in Safari. For
            the best experience, please switch to a different browser.
          </Typography>
        </AlertCard>
      </Stack>
    );
  }

  if (isLoading || !url) {
    return <Loading />;
  }

  return (
    <iframe
      src={url}
      style={{ border: 'none', height: '80vh', width: '100%' }}
    />
  );
};

export const HomeDashboardTab: React.FC = () => {
  const isHomeHidden = useIsHomeHidden();
  const { data, isLoading } = useFetchAnalyticsDashboardUrl();

  // Every landing (login, organization switch, errors) comes through here.
  if (isHomeHidden) return <Navigate to={candidatesLandingPath} replace />;

  const loading = isLoading || !data?.url;

  return (
    <HomeLayout>
      <div id={onboardingElementIds.homePageContainer}>
        <Stack pb={1}>
          <Dashboard isLoading={loading} url={data?.url} />
        </Stack>
      </div>
    </HomeLayout>
  );
};
